import { useIntl } from 'react-intl';
import { Form } from 'antd';

import { PageProps } from '@/types/PageProps';

import { DefaultRouteTabs, SaveButton } from '@/components/_common';

import PurchaseTaxesForm from '@/components/Movements/Purchases/PurchaseDetails/PurchaseTaxesForm';
import { useReleasePurchaseFormContext } from '../../ReleasesPurchaseProvider';
import { useEffect } from 'react';
import Authorities from '@/types/Authority';
import { Status } from '@/utils/enum/statusEnum';
import PurchasesButtonsRepeated from '@/components/Movements/Purchases/PurchasesButtonsRepeated';
import purchaseValidationTabs from '@/utils/functions/purchase/purchaseValidationTabs';
import { PurchaseItemTaxes } from '@/core/domain/purchase/Purchase.types';
import { hasPermissions } from '@/utils/functions/hasPermissions';

export interface FormPurchaseItemSituation {
  situation: Status;
}

function PurchaseTaxesPage({ route }: PageProps) {
  const intl = useIntl();
  const {
    purchaseId,
    isLoading,
    handleSubmit,
    disabled,
    purchase,
    instanceForms,
  } = useReleasePurchaseFormContext();
  const [form] = Form.useForm<PurchaseItemTaxes>(
    instanceForms.purchaseTaxesForm,
  );

  useEffect(() => {
    if (!instanceForms.purchaseTaxesForm && purchase) {
      form.setFieldsValue({ ...purchase });
    }
  }, [purchase, instanceForms.purchaseTaxesForm]);

  return (
    <DefaultRouteTabs
      permissions={route.permissions}
      route={purchaseValidationTabs(route, purchase)}
      baseKey={purchaseId}
      basePath={`/app/movements/purchases/purchasesReleases/${purchaseId}`}
      extra={
        <>
          <SaveButton
            type="primary"
            block
            disabled={
              disabled ||
              !hasPermissions([Authorities.MOVIMENTATION_PURCHASE_EDIT])
            }
            loading={isLoading}
            onClick={handleSubmit}
          >
            {intl.formatMessage({ id: 'commons.entity.save' })}
          </SaveButton>
        </>
      }
    >
      <PurchaseTaxesForm form={form} purchaseId={Number(purchaseId)} />

      <PurchasesButtonsRepeated purchase={purchase} />
    </DefaultRouteTabs>
  );
}

export default PurchaseTaxesPage;
